import React from 'react';
import { format } from 'date-fns';

import { Container, Year, Date } from './styled';
import { useDateTimePicker } from '../..';

export const DateTimeInformation = ({ t }: DateTimeInformationProps) => {
  const { selectedValue, setPickerMode } = useDateTimePicker();

  return (
    <Container>
      <Year onClick={() => setPickerMode('Year')} type="button">
        {format(selectedValue, 'yyyy')}
      </Year>
      <Date onClick={() => setPickerMode('Date')} type="button">
        {`${t(format(selectedValue, 'EEEE'))} ${format(selectedValue, 'd')} ${t(
          format(selectedValue, 'MMM'),
        )}`}
      </Date>
    </Container>
  );
};

export interface DateTimeInformationProps {
  t: (key: string) => string;
}
